<!--  -->
<template>
<div class='container'>
    <div class="title">请选择您的身份</div>
    <div  class="box_one box" @click="goStudent">
        <img src="../../assets/image/geren.png" class="left" alt="">
        <div class="right">个人注册</div>
    </div>
    <div class="box" @click="goCompany">
        <img src="../../assets/image/qiye.png" class="left" alt="">
        <div class="right">企业注册</div>
    </div>
</div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';

export default {
//import引入的组件需要注入到对象中才能使用
components: {},
data() {
//这里存放数据
return {

};
},
//监听属性 类似于data概念
computed: {},
//监控data中的数据变化
watch: {},
//方法集合
methods: {
    // 学员注册
    goStudent(){
        this.$router.push({path:'/studentRegister'})
    },
    // 企业注册
    goCompany(){
        this.$router.push({path:'/companyRegister'})
    }
},
//生命周期 - 创建完成（可以访问当前this实例）
created() {

},
//生命周期 - 挂载完成（可以访问DOM元素）
mounted() {

},
beforeCreate() {}, //生命周期 - 创建之前
beforeMount() {}, //生命周期 - 挂载之前
beforeUpdate() {}, //生命周期 - 更新之前
updated() {}, //生命周期 - 更新之后
beforeDestroy() {}, //生命周期 - 销毁之前
destroyed() {}, //生命周期 - 销毁完成
activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
}
</script>
<style lang='less' scoped>
//@import url(); 引入公共css类
.container{
    width: 100%;
    height: 100vh;
    background-color: #f5f5f5;
    padding: 0 19px;
    box-sizing: border-box;
    overflow: hidden;
    .title{
        font-size: 21px;
        color: #666666;
        margin-top: 24px;
    }
    .box_one{
        margin-top: 50px;
    }
    .box{
        width: 100%;
        height: 113px;
        display: flex;
        margin-bottom: 31px;
        .left{
            height: 100%;
            flex: 1;
        }
        .right{
            flex:1;
            height: 100%;
            line-height: 113px;
            text-align: center;
            background-color: #fff;
            font-size: 23px;
        }
    }
}
</style>